import { FileType } from '@billy/design-system'

import { MimeType } from '../enums'

export const MIME_TYPE_TO_FILE_TYPE_MAP: Record<MimeType, FileType> = {
  [MimeType.ApplicationPdf]: FileType.Pdf,
  [MimeType.ImageJpeg]: FileType.Image,
  [MimeType.ImagePng]: FileType.Image,
}
